import { render, staticRenderFns } from "./Aprovadas.vue?vue&type=template&id=7a7f9710"
import script from "./Aprovadas.vue?vue&type=script&lang=js"
export * from "./Aprovadas.vue?vue&type=script&lang=js"
import style0 from "./Aprovadas.vue?vue&type=style&index=0&id=7a7f9710&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports